export const ProgramManagementQuestions = [
    {
        id: 'sec-pm-001',
        text: 'What is the first step a technician should take before applying a high-priority patch to a production system?',
        options: [
            'Download the patch',
            'Create a change control request',
            'Schedule system downtime',
            'Notify end users'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.6,
        explanation: 'Following proper change management procedures is essential. Even for high-priority patches, creating a change control request is the first step to ensure proper documentation and approval.'
    },
    {
        id: 'sec-pm-002',
        text: 'What is the main difference between RTO and RPO?',
        options: [
            'RTO is for hardware while RPO is for software',
            'RTO is measured in data size while RPO is measured in time',
            'RTO defines time to restore operations while RPO defines acceptable data loss',
            'RTO defines data backup frequency while RPO defines system uptime'
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.6,
        explanation: 'Recovery Time Objective (RTO) defines how quickly operations must be restored, while Recovery Point Objective (RPO) defines how much data loss is acceptable.'
    },
    {
        id: 'sec-pm-003',
        text: 'Which metric would best help determine when to replace hardware before it fails?',
        options: [
            'RPO (Recovery Point Objective)',
            'RTO (Recovery Time Objective)',
            'MTTR (Mean Time To Recovery)',
            'MTBF (Mean Time Between Failures)'
        ],
        correctAnswer: 3,
        domain: 'Security Program Management',
        difficulty: 0.3,
        explanation: 'MTBF helps predict when hardware might fail by measuring the average time between failures, allowing for proactive replacement before actual failure occurs.'
    },
    {
        id: 'sec-pm-004',
        text: 'In a company where the marketing department collects, modifies, and stores sensitive customer data, and the infrastructure team is responsible for its security, what data role corresponds to the customer?',
        options: [
            'Data owner',
            'Data processor',
            'Data subject',
            'Data custodian'
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.9,
        explanation: 'The customer is the data subject as they are the individual about whom the personal data relates. The marketing department acts as the data owner, while the infrastructure team serves as the data custodian.'
    },
    {
        id: 'sec-pm-005',
        text: 'Which risk management tool is best suited for comparing multiple risks based on their likelihood and potential impact?',
        options: [
            'Risk register',
            'Risk assessment checklist',
            'Risk matrix',
            'Risk acceptance criteria'
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.3,
        explanation: 'A risk matrix provides a visual representation for comparing different risks based on their likelihood and impact, helping organizations prioritize their risk management efforts.'
    },
    {
        id: 'sec-pm-006',
        text: 'A company implements a security awareness training program. What type of security control is this?',
        options: [
            'Physical control',
            'Administrative control',
            'Technical control',
            'Corrective control'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.3,
        explanation: 'Security awareness training is an administrative control as it involves policies, procedures, and training to manage human behavior and organizational processes.'
    },
    {
        id: 'sec-pm-011',
        text: 'Which risk management strategy involves paying an insurance company to accept potential losses?',
        options: [
            'Risk mitigation',
            'Risk avoidance',
            'Risk acceptance',
            'Risk transfer'
        ],
        correctAnswer: 3,
        domain: 'Security Program Management',
        difficulty: 0.5,
        explanation: 'Risk transfer involves shifting the potential impact of a risk to another entity, typically through insurance or contractual agreements.'
    },
    {
        id: 'sec-pm-012',
        text: 'Which security assessment role primarily focuses on simulating real-world attacks?',
        options: [
            'Red team',
            'Blue team',
            'Purple team',
            'White team'
        ],
        correctAnswer: 0,
        domain: 'Security Program Management',
        difficulty: 0.1,
        explanation: 'Red teams simulate real-world attacks to test organizational defenses, while blue teams defend, white teams supervise, and purple teams facilitate red/blue collaboration.'
    },
    {
        id: 'sec-pm-014',
        text: 'What is the most important consideration when establishing a data privacy program?',
        options: [
            'Network security',
            'Encryption standards',
            'Backup procedures',
            'Request process for data subject access'
        ],
        correctAnswer: 3,
        domain: 'Security Program Management',
        difficulty: 0.9,
        explanation: 'Under GDPR and similar regulations, having a clear process for handling data subject access requests is crucial for compliance and protecting individual privacy rights.'
    },
    {
        id: 'sec-pm-015',
        text: 'Which topic is most likely to be included within an SDLC security policy?',
        options: [
            'User permissions',
            'Branch protection requirements',
            'Network configurations',
            'Backup schedules'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.6,
        explanation: 'Branch protection requirements are crucial in secure software development lifecycle (SDLC) policies to ensure code integrity and prevent unauthorized changes.'
    },
    {
        id: 'sec-pm-016',
        text: 'During a catastrophic data center failure, what is the primary factor in determining Recovery Time Objective (RTO)?',
        options: [
            'Available IT staff resources',
            'Geographic location of backup sites',
            'Maximum acceptable downtime for critical business operations',
            'Cost of recovery solutions'
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.2,
        explanation: 'RTO is primarily determined by the maximum time the business can tolerate system unavailability without significant impact to operations, regardless of cost or technical constraints.'
    },
    {
        id: 'sec-pm-017',
        text: 'A company is developing their disaster recovery strategy. Which of the following scenarios would most likely justify a hot site implementation?',
        options: [
            'A document archive system accessed quarterly',
            'A development environment for non-critical applications',
            'A monthly accounting system with 48-hour recovery window',
            'A financial trading platform requiring near-zero downtime'
        ],
        correctAnswer: 3,
        domain: 'Security Program Management',
        difficulty: 0.6,
        explanation: 'Hot sites are justified for systems requiring near-immediate recovery and minimal data loss, such as financial trading platforms where downtime directly impacts revenue and customer trust.'
    },
    {
        id: 'sec-pm-018',
        text: 'In the context of business continuity, what distinguishes a crisis management plan from a disaster recovery plan when both are activated during a major incident?',
        options: [
            'Crisis management is for external events while DR is for internal events',
            'Crisis management focuses on organizational decision-making and stakeholder communication while DR focuses on technical recovery',
            'Crisis management is short-term while DR is long-term',
            'Crisis management is for natural disasters while DR is for technical failures'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.8,
        explanation: 'While closely related, crisis management plans focus on organizational leadership, decision-making processes, and stakeholder communication during major incidents, whereas disaster recovery plans specifically detail the technical steps needed to restore systems and operations.'
    },
    {
        id: 'sec-pm-019',
        text: 'What is the primary reason for conducting an audit in a banking environment?',
        options: [
            'Performance evaluation',
            'Regulatory requirement',
            'Service Level Agreement compliance',
            'Self-assessment requirement'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.5,
        explanation: 'Banks are heavily regulated and must undergo audits to comply with various financial regulations and standards.'
    },
    {
        id: 'sec-pm-020',
        text: 'What type of control is best exemplified by an Acceptable Use Policy (AUP)?',
        options: [
            'Detective',
            'Corrective',
            'Preventive',
            'Compensating'
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.1,
        explanation: 'An AUP is a preventive control as it establishes rules and guidelines to prevent security incidents before they occur.'
    },
    {
        id: 'sec-pm-021',
        text: "What is the key difference between decommissioning and isolating a system?",
        options: [
            "Decommissioning involves patching the system, while isolating removes it from the network.",
            "Decommissioning removes the system from service permanently, while isolating temporarily removes it from the network.",
            "Decommissioning involves upgrading the system's hardware, while isolating updates its software.",
            "Decommissioning moves the system to a different physical location, while isolating creates a virtual copy."
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.0,
        explanation: "Decommissioning is the permanent removal of a system from service, including data erasure and hardware disposal. Isolation temporarily removes a system from the network, often for investigation or remediation, but it can be brought back online. The other options are incorrect interpretations of the terms."
    },
    {
        id: 'sec-pm-022',
        text: "Who is accountable for the protection and appropriate use of a specific dataset within an organization?",
        options: [
            "Data Custodian",
            "Data Steward",
            "Data Owner",
            "Data Processor"
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.5,
        explanation: "The Data Owner holds ultimate responsibility for the data. The Data Custodian implements security controls. The Data Steward ensures data quality. A Data Processor (like a cloud provider) processes data on behalf of the Controller."
    },
    {
        id: 'sec-pm-023',
        text: "Which role is primarily concerned with maintaining data quality, accuracy, and consistency?",
        options: [
            "Data Controller",
            "Data Custodian",
            "Data Steward",
            "Data Protection Officer"
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.5,
        explanation: "The Data Steward focuses on data quality. The Data Controller determines processing purposes. The Custodian implements security. The Data Protection Officer oversees data protection compliance."
    },
    {
        id: 'sec-pm-024',
        text: "Implementing access controls and security measures to protect data is the responsibility of which role?",
        options: [
            "Data Owner",
            "Data Custodian",
            "Data Steward",
            "Data Subject"
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.5,
        explanation: "The Data Custodian is responsible for implementing security controls. The Owner defines data usage. The Steward ensures data quality. The Data Subject is the individual whose data is being processed."
    },
    {
        id: 'sec-pm-025',
        text: "Which role determines the purpose and means of processing personal data?",
        options: [
            "Data Processor",
            "Data Controller",
            "Data Custodian",
            "Data Steward"
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.5,
        explanation: "The Data Controller makes decisions about data processing. The Processor acts on the Controller's instructions. The Custodian handles security. The Steward focuses on data quality."
    },
    {
        id: 'sec-pm-026',
        text: "What criteria would MOST strongly suggest the need to decommission a business system?",
        options: [
            "The system is no longer used by the company.",
            "The system has reached its end-of-life and is no longer supported by the vendor.",
            "The system frequent network connectivity issues.",
            "The system needs to be migrated to a new data center location."
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.5,
        explanation: "End-of-life status and lack of vendor support are primary drivers for decommissioning due to security and compatibility risks. Routine patching, network issues, and data center migrations can be addressed without decommissioning."
    },
    {
        id: 'sec-pm-027',
        text: "An organization is outsourcing its customer support to a third-party vendor. The contract stipulates that the vendor must comply with specific security controls regarding customer data. However, after a security audit, it's discovered that the vendor has not fully implemented these controls. Which of the following BEST describes the organization's residual risk?",
        options: [
            "The risk has been completely transferred to the vendor.",
            "The organization retains the ultimate responsibility and therefore the residual risk despite the contract.",
            "The residual risk is limited to the financial penalties outlined in the contract.",
            "The risk is now shared equally between the organization and the vendor."
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.8,
        explanation: "While contracts can define responsibilities, the organization ultimately remains accountable for protecting its data, even when outsourced. The residual risk is what remains after controls are implemented (or in this case, not fully implemented by the vendor). Contracts can mitigate some financial impact, but not the overall risk to the organization's reputation and data."
    },
    {
        id: 'sec-pm-028',
        text: 'In evaluating insurance options for ransomware protection, a startup determines the premiums are too expensive and decides to implement internal controls instead. What risk response strategy is this?',
        options: [
            'Risk mitigation',
            'Risk acceptance',
            'Risk avoidance',
            'Risk transfer'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.5,
        explanation: 'By choosing to handle ransomware risk internally rather than purchasing insurance, the organization is accepting the risk. They\'ve decided to bear the potential costs themselves rather than transferring it to an insurance provider.'
    },
    {
        id: 'sec-pm-029',
        text: 'A company is evaluating different risk response strategies for their critical systems. In which scenario is risk transference the most appropriate approach?',
        options: [
            'Implementing additional security controls',
            'Purchasing cyber insurance coverage',
            'Discontinuing vulnerable services',
            'Accepting the current risk level'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.6,
        explanation: 'Risk transference involves shifting the potential impact of a risk to another party. Purchasing cyber insurance is a classic example of risk transference, where financial impact is transferred to the insurance provider in exchange for premium payments.'
    },

    {
        id: 'sec-pm-030',
        text: 'Which risk management approach is demonstrated when an organization implements multi-factor authentication after identifying weak password practices?',
        options: [
            'Risk acceptance',
            'Risk avoidance',
            'Risk mitigation',
            'Risk transference'
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.5,
        explanation: 'Risk mitigation involves implementing controls or countermeasures to reduce risk to an acceptable level. Adding multi-factor authentication is a mitigation strategy that reduces the risk of unauthorized access while allowing the business process to continue.'
    },
    {
        id: 'sec-pm-031',
        text: 'Which type of agreement is typically used to establish Quality of Service (QoS) metrics between two organizations?',
        options: [
            'Service Level Agreement',
            'Memorandum of Understanding',
            'Information Security Agreement',
            'Business Partnership Agreement'
        ],
        correctAnswer: 0,
        domain: 'Security Program Management',
        difficulty: 0.2,
        explanation: 'A Service Level Agreement (SLA) is a formal contract that defines specific metrics, including QoS parameters, that must be met between service providers and their customers.'
    },
    {
        id: 'sec-pm-032',
        text: 'A company allows employees to use personal devices for work after obtaining IT approval. Which policy is being implemented?',
        options: [
            'BYOD',
            'CYOD',
            'MDM',
            'COPE'
        ],
        correctAnswer: 0,
        domain: 'Security Program Management',
        difficulty: 0.6,
        explanation: 'This is Bring Your Own Device (BYOD) because employees use their personal devices. Choose Your Own Device (CYOD) involves selecting from company-approved devices, while Corporate Owned, Personally Enabled (COPE) and Mobile Device Management (MDM) involve different aspects of device management.'
    },
    {
        id: 'sec-pm-033',
        text: 'Which security standard requires merchants to maintain a vulnerability management program and regularly test security systems and processes?',
        options: [
            'ISO 27001',
            'SOC 2',
            'PCI DSS',
            'NIST 800-53'
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.3,
        explanation: 'The Payment Card Industry Data Security Standard (PCI DSS) specifically requires organizations that handle credit card data to maintain security controls, including vulnerability management and regular testing. The other standards, while comprehensive, are not specifically focused on payment card security.'
    },
    {
        id: 'sec-pm-034',
        text: 'In business continuity planning, what metric indicates the longest duration a business function can be unavailable before causing unacceptable consequences?',
        options: [
            'RTO',
            'MTD',
            'RPO',
            'MTTBF'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.4,
        explanation: 'Maximum Tolerable Downtime (MTD) specifically measures the maximum time a business can survive without a critical function. While RTO defines recovery goals and RPO addresses data loss tolerance, MTD determines the absolute limit before significant business damage occurs.'
    },
    {
        id: 'sec-pm-035',
        text: 'In disaster recovery planning, which metric is measured in units of time and indicates acceptable data loss?',
        options: [
            'MTTR',
            'RPO',
            'MTTF',
            'RTO'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.3,
        explanation: 'Recovery Point Objective (RPO) specifically measures the maximum acceptable period of data loss in units of time, such as hours or minutes. This differs from RTO which measures recovery time, and MTTR/MTBF which measure system reliability.'
    },
    {
        id: 'sec-pm-036',
        text: 'What is the next critical step after developing a Business Continuity Planning (BCP) mission statement?',
        options: [
            'Conduct a Business Impact Analysis (BIA)',
            'Develop recovery procedures',
            'Test the BCP plan',
            'Assign team responsibilities'
        ],
        correctAnswer: 0,
        domain: 'Security Program Management',
        difficulty: 0.5,
        explanation: 'After establishing a BCP mission statement, conducting a Business Impact Analysis (BIA) is the next critical step. The BIA helps identify and prioritize critical business functions, determines potential impacts of disruptions, and provides the foundation for developing appropriate recovery strategies and procedures.'
    },
    {
        id: 'sec-pm-037',
        text: 'When should incident response strategy development occur in relation to security incidents?',
        options: [
            'Before incidents occur',
            'During incident detection',
            'After incident containment',
            'During recovery phase'
        ],
        correctAnswer: 0,
        domain: 'Security Program Management',
        difficulty: 0.4,
        explanation: 'Incident response strategies should be developed preventatively, before incidents occur. This proactive approach ensures that organizations have well-defined procedures and responses ready when incidents do occur, rather than trying to develop strategies during or after an incident.'
    },
    {
        id: 'sec-pm-038',
        text: 'A software development team implements a practice where developers integrate their code changes into a shared repository several times throughout the day. Which modern development concept does this represent?',
        options: [
            'Continuous Integration (CI)',
            'Continuous Delivery (CD)',
            'Continuous Deployment',
            'Continuous Monitoring'
        ],
        correctAnswer: 0,
        domain: 'Security Program Management',
        difficulty: 0.5,
        explanation: 'Continuous Integration (CI) is a development practice where team members frequently integrate their code changes into a shared repository, usually several times per day. Each integration is verified by automated builds and tests, helping to detect integration issues early in the development process.'
    },
    {
        id: 'sec-pm-039',
        text: 'Which agreement type defines specific metrics and performance targets for service providers?',
        options: [
            'Interconnection Security Agreement',
            'Information Sharing Agreement',
            'Service Level Agreement',
            'Mutual Aid Agreement'
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.4,
        explanation: 'A Service Level Agreement (SLA) establishes measurable service standards, performance metrics, and expectations between service providers and their clients, including security-related requirements.'
    },
    {
        id: 'sec-pm-040',
        text: 'An organization needs to formalize security requirements for connecting their network with a partner agency. Which document should they develop?',
        options: [
            'Non-Disclosure Agreement',
            'Interconnection Security Agreement',
            'Memorandum of Understanding',
            'Business Associate Agreement'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.6,
        explanation: 'An Interconnection Security Agreement (ISA) documents the security requirements, controls, and responsibilities for establishing and maintaining a secure connection between two organizations\' networks.'
    },
    {
        id: 'sec-pm-041',
        text: 'Under data protection regulations, which role determines the purposes and means of processing personal data?',
        options: [
            'Data Processor',
            'Data Controller',
            'Data Custodian',
            'Data Steward'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.6,
        explanation: 'A Data Controller determines why and how personal data should be processed, making key decisions about data collection purposes and processing methods.'
    },
    {
        id: 'sec-pm-042',
        text: 'In a disaster recovery plan, what metric defines the maximum acceptable data loss measured in time?',
        options: [
            'RTO',
            'MTTR',
            'RPO',
            'MTTF'
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.3,
        explanation: 'Recovery Point Objective (RPO) specifies the maximum period of data loss that an organization can tolerate in case of a disaster, influencing backup frequency and strategy.'
    },
    {
        id: 'sec-pm-043',
        text: 'Which certificate validation method provides real-time verification of a certificate\'s status?',
        options: [
            'CRL',
            'OCSP',
            'ARL',
            'CSR'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.8,
        explanation: 'Online Certificate Status Protocol (OCSP) enables real-time validation of digital certificates, providing immediate status information without downloading entire revocation lists.'
    },
    {
        id: 'sec-pm-044',
        text: 'What document is generated to request a digital certificate from a Certificate Authority?',
        options: [
            'CSR',
            'CRL',
            'ARL',
            'RA'
        ],
        correctAnswer: 0,
        domain: 'Security Program Management',
        difficulty: 0.9,
        explanation: 'A Certificate Signing Request (CSR) contains the public key and organization information necessary for a Certificate Authority to issue a digital certificate.'
    },
    {
        id: 'sec-pm-045',
        text: 'Which mechanism is used to distribute lists of revoked certificates to relying parties?',
        options: [
            'OCSP',
            'RA',
            'CRL',
            'CSR'
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.8,
        explanation: 'Certificate Revocation Lists (CRLs) are periodically published lists of digital certificates that have been revoked by the issuing Certificate Authority before their scheduled expiration date.'
    },
    {
        id: 'sec-pm-046',
        text: 'Which disaster recovery test involves reviewing documented procedures with stakeholders but does NOT include any actual system testing?',
        options: [
            'Tabletop exercise',
            'Structured walk-through',
            'Read-through test',
            'Simulation test'
        ],
        correctAnswer: 2,
        domain: 'Security Program Management',
        difficulty: 0.5,
        explanation: 'A read-through test is the most basic form of disaster recovery testing, involving only document review without any actual system testing or simulation activities.'
    },
    {
        id: 'sec-pm-047',
        text: 'During which type of disaster recovery test do critical systems continue operating at the primary site while recovery systems are tested at the alternate site?',
        options: [
            'Full-interruption test',
            'Parallel test',
            'Simulation test',
            'Structured walk-through'
        ],
        correctAnswer: 1,
        domain: 'Security Program Management',
        difficulty: 0.6,
        explanation: 'In a parallel test, the recovery systems are tested at the alternate site while primary systems continue operating normally, allowing validation of recovery capabilities without disrupting business operations.'
    },
];